import React from 'react'
import { Button } from 'antd'
import { setShowLogin } from '../../../redux/auth/actions'

const styles = {
    container: {
        width: 400,
        maxHeight: '85vh',
        overflow: 'auto',
        padding: '2em',
    },
    body: {
        textAlign: 'center',
        marginTop: '0.64em'
    },
    footer: {
        marginTop: '1em',
    }
}

const InvalidCode = () => {

    const onButtonClick = () => {
        window.location.replace('/')
    }

    return (
        <>
            <div style={styles.container}>
                <div style={styles.body}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <b>This link is invalid or has expired</b>
                        <span style={{ marginTop: '1em' }}>Contact your administrator to recieve a new registration link.</span>
                    </div>

                    <div style={styles.footer}>
                        <Button style={{ marginTop: '1em' }} type='primary' onClick={onButtonClick}>Return To Login</Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InvalidCode
